import EntityType from '@enums/EntityType';

export default function isEntityPropertyValue(entityType) {
  switch (entityType) {
    case EntityType.ACTIVITY_PROPERTY_VALUE:
    case EntityType.GROUP_PROPERTY_VALUE:
    case EntityType.ROLE_PROPERTY_VALUE:
      return true;
    default:
      return false;
  }
}
